import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import Dropdown from '../../components/Dropdown';
import actions from '../../state/actions';
import { localize } from '../../i18n';

class WorkordersTopBarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'reset',
      filterKey: this.props.filterKey,
      sortKey: this.props.sortKey,
      requestSort: 'close',
      requestFilter: 'close',
    };
  }

  render() {
    const filterOptions = [{
      filterKey: 'all',
      name: this.props.t('All'),
    }, {
      filterKey: 'new',
      name: this.props.t('New'),
    }, {
      filterKey: 'open',
      name: this.props.t('Open'),
    }, {
      filterKey: 'in_progress',
      name: this.props.t('In Progress'),
    }, {
      filterKey: 'closed',
      name: this.props.t('Closed'),
    }, {
      filterKey: 'canceled',
      name: this.props.t('Canceled'),
    }, {
      filterKey: 'late',
      name: this.props.t('Late'),
    }, {
      filterKey: 'assigned',
      name: this.props.t('Assigned to Me'),
    }, {
      filterKey: 'normal',
      name: this.props.t('Priority - Normal'),
    }, {
      filterKey: 'high',
      name: this.props.t('Priority - High'),
    }, {
      filterKey: 'immediate',
      name: this.props.t('Priority - Immediate'),
    }];

    const sortOptions = [{
      sortKey: '-status',
      name: this.props.t('Status Desc.'),
    }, {
      sortKey: 'status',
      name: this.props.t('Status Asc.'),
    }, {
      sortKey: '-due_date',
      name: this.props.t('Due Date Desc.'),
    }, {
      sortKey: 'due_date',
      name: this.props.t('Due Date Asc.'),
    }, {
      sortKey: '-_created',
      name: this.props.t('Submitted Desc.'),
    }, {
      sortKey: '_created',
      name: this.props.t('Submitted Asc.'),
    }, {
      sortKey: '-priority',
      name: this.props.t('Priority Desc.'),
    }, {
      sortKey: 'priority',
      name: this.props.t('Priority Asc.'),
    }];


    const filterItems = filterOptions.map(item => (
      <li key={item.filterKey} className={`${(item.filterKey === this.state.filterKey) ? 'uk-active' : ''}`}>
        <span
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            let sortKey = this.state.sortKey;
            if (item.filterKey === 'all') {
              sortKey = '-priority';
            }
            this.setState({
              status: 'filtering',
              filterKey: item.filterKey,
              sortKey,
              requestFilter: 'close',
            });
            this.props.onFilter(item.filterKey, this.state.sortKey);
          }}
        >
          {item.name}
        </span>
      </li>
    ));


    const sortItems = sortOptions.map(item => (
      <li key={item.sortKey} className={`${(item.sortKey === this.state.sortKey) ? 'uk-active' : ''}`}>
        <span
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              status: 'sorting',
              sortKey: item.sortKey,
              requestSort: 'close',
            });
            this.props.onFilter(this.state.filterKey, item.sortKey);
          }}
        >
          {item.name}
        </span>
      </li>
    ));

    const currentFilter = _.find(filterOptions, { filterKey: this.state.filterKey }).name;
    const currentSort = _.find(sortOptions, { sortKey: this.state.sortKey }).name;

    return (
      <div>
        <Dropdown
          href="#filter-dropdown"
          label={[
            <i className="material-icons" key="1">&#xE152;</i>,
            <span key="2" className="dropdown-label">{currentFilter}</span>,
            <i className="material-icons" key="3">&#xE313;</i>,
          ]}
          request={this.state.requestFilter}
          onChange={(changeRequest) => {
            this.setState({
              requestFilter: changeRequest === true ? 'open' : 'close',
            });
          }}
          wrapperClassName="uk-button-dropdown"
          className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button"
        >
          <ul className="uk-nav uk-nav-dropdown">
            {filterItems}
          </ul>
        </Dropdown>

        <Dropdown
          href="#sort-dropdown"
          label={[
            <i className="material-icons" key="1">&#xE164;</i>,
            <span key="2" className="dropdown-label">{currentSort}</span>,
            <i className="material-icons" key="3">&#xE313;</i>,
          ]}
          request={this.state.requestSort}
          onChange={(changeRequest) => {
            this.setState({
              requestSort: changeRequest === true ? 'open' : 'close',
            });
          }}
          wrapperClassName="uk-button-dropdown"
          className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button"
        >
          <ul className="uk-nav uk-nav-dropdown">
            {sortItems}
          </ul>
        </Dropdown>
      </div>
    );
  }
}

WorkordersTopBarFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
  filterKey: PropTypes.string,
  sortKey: PropTypes.string,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    filter: {
      workordersList: {
        filterKey,
        sortKey,
      },
    },
  } = state;
  return {
    filterKey,
    sortKey,
  };
};

const mapDispatchToProps = dispatch => ({
  onFilter(filterKey, sortKey) {
    dispatch(actions.filterWorkorder(filterKey, sortKey));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(WorkordersTopBarFilter));



// WEBPACK FOOTER //
// ./src/views/workorders/WorkordersTopBarFilter.js